import { render, staticRenderFns } from "./AVIChat.vue?vue&type=template&id=cf9f3bd6&scoped=true"
import script from "./AVIChat.vue?vue&type=script&setup=true&lang=js"
export * from "./AVIChat.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AVIChat.vue?vue&type=style&index=0&id=cf9f3bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9f3bd6",
  null
  
)

export default component.exports